import type { ExcludeReadingOrderUpdatePanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";
import { useDeleteExcludeReadingOrderFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: ExcludeReadingOrderUpdatePanelFragment;
};

export function ExcludeReadingOrderUpdatePanel({ fragment }: Props) {
  const { t } = useTranslation();
  const [deleteAttribute] = useDeleteExcludeReadingOrderFromPanelMutation();

  const onSave = async () => {};

  const onDelete = async () => {
    await deleteAttribute({
      variables: { attributeId: fragment.id },
      update(cache) {
        const id = cache.identify(fragment);
        cache.evict({ id });
        cache.gc();
      },
    });
  };

  return (
    <AttributePanel
      title={t("ExcludeReadingOrderUpdatePanel.title")}
      onSubmit={onSave}
      onDelete={onDelete}
    />
  );
}
